import React from "react";
import Hero from "@/components/optina/Hero";
import PartnersLogosCarousel from "@/components/optina/PartnersLogosCarousel";
import PillarsBand from "@/components/optina/PillarsBand";
import Testimonials from "@/components/optina/Testimonials";
import Services from "@/components/optina/Services";
import BlogPreview from "@/components/optina/BlogPreview";
import FaqSection from "@/components/optina/FaqSection";
import EnergyForm from "@/components/optina/EnergyForm";
import TrustSection from "@/components/optina/TrustSection";
import InterlocuteurSection from "@/components/optina/InterlocuteurSection";
import PERSection from "@/components/optina/PERSection";
import useSeo from "@/hooks/useSeo";

/**
 * Home page — section order strict (per latest spec):
 *   1. Hero
 *   2. PillarsBand (Temps / Argent / Tranquillité — bande #F9F9F9)
 *   3. Testimonials (bande défilante avis clients)
 *   4. Services (offre Assurance) — pas de carousel de logos partenaires ici
 *   5. TrustSection
 *   6. PERSection
 *   7. BlogPreview
 *   8. FaqSection
 *   9. EnergyForm
 *  10. InterlocuteurSection
 */
export default function Home() {
  useSeo({
    title: "OPTINA — Courtier indépendant assurance & énergie · Aurillac & Paris",
    description:
 "Courtier indépendant en assurance et énergie. Je compare, négocie et optimise vos contrats pour alléger vos charges — un seul interlocuteur, à vos côtés."});

  return (
    <main data-testid="home-page">
      <Hero />
      <PartnersLogosCarousel />
      <PillarsBand />
      <Testimonials />
      <Services />
      <TrustSection />
      <PERSection />
      <BlogPreview />
      <FaqSection />
      <EnergyForm />
      <InterlocuteurSection />
    </main>
  );
}
